var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 75,
    viewBox: "0 0 83 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5004 31.7996C39.5637 31.7996 46.1003 25.263 46.1003 17.1996C46.1003 9.13625 39.5637 2.59961 31.5004 2.59961C23.437 2.59961 16.9004 9.13625 16.9004 17.1996C16.9004 25.263 23.437 31.7996 31.5004 31.7996Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1003 70.4992C33.9003 70.5992 32.7004 70.5992 31.4004 70.5992C15.4004 70.5992 2.40039 63.7992 2.40039 55.3992C2.40039 46.9992 15.4004 40.1992 31.4004 40.1992C47.4004 40.1992 60.4004 46.9992 60.4004 55.3992C60.5004 63.0992 49.4003 69.5992 35.1003 70.4992Z",
    fill: "white",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 70.5996H45.4",
    stroke: "#09314C",
    strokeWidth: 3.76,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9006 72.4998L28.1006 58.6998L39.4006 47.3998L47.5006 55.4998L71.2006 31.7998L82.5006 43.0998L53.1006 72.4998C49.1006 75.5998 45.4006 75.6998 41.9006 72.4998Z",
    fill: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9ded8909f4185d723840ce35c8d36015.svg";
export { ForwardRef as ReactComponent };